import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import introduction from "./components/introduction";
import hrtf from "./components/hrtf";
import dtf from "./components/dtf";
import gammatone from "./components/gammatone";
import innerHair from "./components/inner-hair";
import comparison from "./components/comparison";

const principle: Slide = {
  title: "Baumgartner’s model for saggital plane localization",
  description:
    "Baumgartner's model for saggital plane localization is a part of the Auditory Modelling Toolbox(AMT) and can be used for localising sound sources.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            { name: "Introduction" },
            { name: "Saggital Plane HRTFs" },
            { name: "Saggital Plane DTFs" },
            { name: "Gammatone Filter Bank" },
            { name: "Inner Hair Cells Firing" },
            { name: "Comparison (Similarity Index)" },
          ],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], [], [], []],
      components: [introduction, hrtf, dtf, gammatone, innerHair, comparison],
    },
  },
};

export default principle;
